export const environment = {
    production: false,
    apiUrl: 'https://critters.zone/api',
    signalRBase: 'https://critters.zone/ws',
    baseUrl: 'https://critters.zone',
    tokenIss: 'critters.zone',
    environmentName: 'sandbox',
    faroUrl: '', // Grafana Faro collector URL; Faro only initializes when this is non-empty
    baseHref: '/' //this must be kept in sync with  angular.json => projects.CritterClient.architect.build.configurations.sandbox.baseHref && deployUrl or you will have a very bad day
};
